import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { IPodcasts } from '../../../core/models/disciplines';
import { IActiveItem } from '../models/modules';

interface PodcastState {
  podcasts: IPodcasts[];
  podcast: IActiveItem | null;
  setPodcasts: (podcast: IPodcasts[]) => void;
  setPodcast: (podcast: IActiveItem) => void;
  resetPodcast: () => void;
}

export const usePodcastStore = create<PodcastState>()(
  persist(
    (set) => ({
      podcasts: [],
      podcast: null,
      setPodcasts: (podcast: IPodcasts[]) => set({ podcasts: podcast }),
      setPodcast: (podcast: IActiveItem) => set({ podcast: podcast }),
      resetPodcast: () => set({ podcasts: [], podcast: null })
    }),
    {
      name: 'discipline-podcast',
    }
  )
);